import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import { serviceSupportCasesApi } from "@/services/support-cases";
import { SupportCaseItemType } from "@/schemas/index";

const LayoutPageCaseView = lazy(() => import("./layout/index"));

export type LoaderDataCaseViewType = SupportCaseItemType;

export const loaderDataCaseView = async (args: any) => {
  try {
    const { caseId } = args.params;

    if (!caseId) {
      throw new Error("CASE_ID_REQUIRED");
    }
    const [caseData] = await Promise.all([
      serviceSupportCasesApi.fetchSupportCaseById(caseId),
    ]);

    if (!caseData) {
      throw new Error("CASE_NOT_FOUND");
    }

    return caseData;
  } catch (err) {
    console.error(err);
    throw new Error("CASE_NOT_FOUND");
  }
};

export const routerPageCaseView: RouterItemType = {
  path: "/support/cases/:caseId",
  authorize: true,
  element: <LayoutPageCaseView />,
  loader: loaderDataCaseView,
};
